export default {
  addNewTemplate: 'افزودن قالب جدید',
  save: 'ذخیره',
  title: 'عنوان',
  description: 'توضیحات',
  tag: 'برچسب',
  categoryTag: 'برچسب دسته',
  askLocation: 'پرکردن مکان',
  askProfilePhoto: 'پرکردن عکس نمایه',
  askSocialInfo: 'پرکردن اطلاعت شبکه‌های اجتماعی',
  askSelfDocuments: 'پرکردن اسناد شخصی',
  askRelatedDocs: 'پرکردن اسناد سازمانی',
  single: 'یکتا باشد',
  required: 'الزامی',
  providerTemplateSaved(isUpdate: boolean) {
    if (isUpdate) {
      return 'قالب با موفقیت به‌روزرسانی شد';
    }
    return 'قالب با موفقیت ایجاد شد';
  },
  cancel: 'لغو',
  editSurvey: 'ویرایش پرسشنامه',
  templateRemoved: 'قالب مورد نظر حذف شد',
  templateRestored: 'قالب مورد نظر بازیابی شد',
  showDeletedTemplates: 'نمایش قالب‌های حذف شده',
  hideDeletedTemplates: 'مخفی کردن قالب‌های حذف شده',
  editAdmins: 'ویرایش مدیران',
  templateAdmins: 'مدیران قالب',
  searchUserByMobile: 'جستجوی کاربر با موبایل',
  areYouSureToRemoveThisUser: 'آیا از حذف این کاربر مطمئن هستید؟',
  adminRemoved: 'مدیر قالب با حذف شد',
  adminAdded: 'مدیر قالب با اضافه شد',
  templates: 'قالب‌ها',
};
